/**
 * Registration Component
 *
 * Simple registration page that redirects to WorkOS AuthKit for sign-up.
 * WorkOS handles all authentication methods (email/password, Google OAuth, etc.)
 * Identity verification happens post-registration via /verify route.
 */
import React, { useEffect } from 'react';
import { useAuth } from '@shared/context';
import { Navigate, useSearchParams } from 'react-router-dom';
import Loader from '../loader/loader.component';

import './register.scss';

const Register = () => {
  const { signIn, isAuthenticated, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  // Capture partner slug from URL (?partner=hgfg) into sessionStorage
  // so it survives the WorkOS auth redirect
  useEffect(() => {
    const partner = searchParams.get('partner');
    if (partner) {
      sessionStorage.setItem('esig-partner-slug', partner);
    }
  }, [searchParams]);

  // If already authenticated, redirect to dashboard
  if (isAuthenticated) {
    return <Navigate to="/accounts/me" replace />;
  }

  return (
    <section className="join">
      <div className="container">
        <div
          className="row"
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <div className="col form">
            <div className="row">
              <div className="col">
                <div className="form-group title">
                  <span className="fa fa-lock"></span>
                  <label className="text-center call-txt">
                    Create an account
                  </label>
                </div>

                <div className="form-group">
                  <div className="col-md-12 pad">
                    <p style={{ textAlign: 'center', marginBottom: '24px', color: '#666' }}>
                      Sign up with your email or Google account
                    </p>
                  </div>
                </div>

                <div className="form-group">
                  <div className="col-md-12 pad">
                    {isLoading ? (
                      <Loader />
                    ) : (
                      <button
                        name="create-account"
                        type="button"
                        className="btn-register g-recaptcha"
                        onClick={() => signIn()}
                      >
                        Create account
                      </button>
                    )}
                  </div>
                </div>

                {/* Verification info */}
                <div className="form-group verification-info">
                  <p className="verification-note">
                    <span className="fa fa-info-circle"></span>
                    After registration, you'll be able to verify your identity to complete transactions.
                  </p>
                </div>

                <div className="form-group" style={{ display: 'flex' }}>
                  <div className="col-md-4 pad text-center">
                    <img
                      width="50"
                      src="/assets/images/money-back-guarantee.png"
                      alt="money-back-guarantee.png"
                    />
                  </div>
                  <div className="col-md-4 pad text-center">
                    <img
                      width="60"
                      src="/assets/images/premium-quality-guarantee.png"
                      alt="premium-quality-guarantee.png"
                    />
                  </div>
                  <div className="col-md-4 pad text-center">
                    <img
                      width="50"
                      src="/assets/images/secure-checkout-guarantee.png"
                      alt="secure-checkout-guarantee.png"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 text-center already">
                Already have an account?
                <br />
                <a href="login">
                  <span>Log in</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;
